<template>
  <div class="d-flex align-center justify-center fill-height">
    <v-card>
      <v-toolbar color="primary" max-height="64">
        <v-toolbar-title class="mx-5 altfont" v-if="model && !isSmallScreen">{{ model.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="isAdmin && !isResourcePublished"
          icon
          variant="plain"
          color="warning"
          v-tooltip.bottom-center="$t('cortona.ipc.resource-not-published', { status: model && model.status })"
          class="d-print-none"
        >
          <v-icon>mdi-alert-outline</v-icon>
        </v-btn>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text v-if="model.path">
        <img :src="model.path" style="max-height: 75vh; max-width: 75vw; display: block;" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useDisplay } from 'vuetify';
import { useAccountStore } from '@/stores/account';

const props = defineProps<{
  model?: any;
  iframeStyle?: string;
}>();

const emit = defineEmits<{
  closeDialog: [];
}>();

const { width } = useDisplay();
const accountStore = useAccountStore();

const isSmallScreen = computed(() => width.value < 768);
const isAdmin = computed(() => accountStore.account?.userType === 'ADMIN');
const isResourcePublished = computed(() => !props.model || props.model.status === 'PUBLISHED');

const closeDialog = () => emit('closeDialog');
</script>

<style lang="scss" scoped>
.altfont {
  font-family: 'Saira Semi Condensed', sans-serif;
  font-size: 1.5rem !important;
}
</style>
